module.exports = __webpack_public_path__ + "img/cloud.58ca6a1f.png";